<template>
  <div v-if="preloadAdsShow" class="preLoadAds">
    <HCacheImage v-for="eachAd in adData" :src="eachAd['Icon']" :key="adData['Icon']" width="1px" height="1px"/>
  </div>
  <div class="parentDiv">
    <div ref="topContainerRef">
      <div v-if="isShowTopDownDiv" class="ignore-topDownDiv">
        <img @click="clickTopCloseDown" :src="icon_down_close" height="18px" alt="">
        <img :src="icon_logo" height="29px" alt="" style="margin:0 10px">
        <div style="display: flex;flex-direction: column;flex:1;align-items: flex-start;justify-content: center;">
          <div :style="hcf.getTextStyle({
          addSize:-1.5,color:'#444'})">下载APP,获取更多福利
          </div>
          <div :style="hcf.getTextStyle({
          addSize:-3,color:'#888'})">真人娱乐,电子棋牌等尽在一手掌握
          </div>
        </div>
        <img @click="clickTopDown" :src="icon_down_btn" height="29px" alt="">
      </div>
      <div v-if="HNewGameUIConfig.newGameUIType === 0" class="topLogoServiceDiv">
        <img :src="logo" height="33px;" alt="">
        <div style="flex:1"/>
        <div @click="openService"
             style="display: flex;flex-direction: row;align-items: center;justify-content: center;">
          <van-badge :content="noRedMsgCount" :show-zero="false">
            <img :src="iconService" width="28px" height="28px" alt="" style="margin-right: 3px;">
          </van-badge>
          <div :style="hcf.getTextStyle({
              addSize:-1,color:'main',marginBottom:5,
            })">客服
          </div>
        </div>
      </div>
      <MGHomeMiddle :bannerData="bannerData" :openService="openService" :noRedMsgCount="noRedMsgCount"
                    :noticeList="noticeList" style="margin-bottom:8px;"/>
    </div>
    <div v-if="HNewGameUIConfig.newGameUIType === 4" :style="{
      backgroundImage:`url(${jmttFlagBg})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      backgroundPosition: 'left',
      width:'100px',
      color:'white',
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      marginTop:'10px',
      fontSize:'16px',
    }">
      官方游戏
    </div>
    <HomeBottomGameArea v-if="isShowBottomDiv" :bottomContainerHeight="bottomContainerHeight"/>
    <div v-if="HNewGameUIConfig.newGameUIType === 4"
         style="width:100%;height:3px;background-color: #eee;margin:10px 0;"/>
    <div v-if="HNewGameUIConfig.newGameUIType === 4" :style="{
      backgroundImage:`url(${jmttFlagBg})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      backgroundPosition: 'left',
      width:'100px',
      color:'white',
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      fontSize:'16px',
    }">
      合作游戏
    </div>
    <div :style="{
    display: 'flex',
    flexWrap: 'wrap',
    padding: '10px 10px 0 10px',
    alignItems: 'center',
    width:'100%',
    justifyContent:'center',
  }">
      <div @click="clickHeZuoGameItem(eachItem)" v-for="(eachItem,index) in heZuoGameList" :key="index" :style="{
          marginBottom:'7px',width:eachHeZuoImgWidth,position:'relative'
        }">
        <HCacheImage :src="eachItem['Icon']" :width="eachHeZuoImgWidth"/>
        <div v-if="eachItem['Status'] === 1"
             style="display:flex;align-items: center;justify-content:center;width:100%;background-color:#000a;height:100%;position: absolute;top:0;left:0;">
          <div :style="hcf.getTextStyle({
                  color:'white',addSize:1,fontWeight:'bold'
              })">
            维护中
          </div>
        </div>
      </div>
    </div>
  </div>
  <van-dialog v-model:show="showAdModal" :show-confirm-button="false" style="background-color: #0000">
    <div style="display: flex;flex-direction: column;">
      <HSwiper :data="adData" height="300px"/>
      <div @click="closeBtn" class="closeBtn">
        <van-icon name="cross" size="25px" color="#fff"/>
      </div>
    </div>
  </van-dialog>
</template>


<script setup>
  import {emitter, hcf, kRelease} from "@/components/utils/HComFunctions.js";
  import logo from "@/assets/icons/replaces/logo_domain.png"
  import {onMounted} from "vue";
  import HSwiper from "@/components/utils/HSwiper.vue";
  import MGHomeMiddle from "@/components/pages/home/MGHomeMiddle.vue";
  import HomeBottomGameArea from "@/components/pages/home/HomeBottomGameArea.vue";
  import HCacheImage from "@/components/utils/HCacheImage.vue";
  import {useHComApi} from "@/hooks/useHComApi.js";

  import icon_down_btn from '@/assets/icons/home/top_download_btn.png';
  import icon_down_close from '@/assets/icons/home/top_download_close.png';
  import icon_logo from '@/assets/icons/logo_biao.png';
  import {hdi} from "@/components/utils/HDeviceInfo.js";
  import {showDialog, showToast} from "vant";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {useClickModal} from "@/hooks/useClickModal.js";
  const clickModal = useClickModal();
  let useComApi = useHComApi();
  const iconService = hcf.getNewGameUIIcon("service.png");

  const jmttFlagBg = hcf.getNewGameUIIcon("flag_gfyx.png");

  let bannerData = useComApi.homeBannerList;
  let adData = useComApi.homeAdList;
  let noticeList = useComApi.homeNoticeList;
  const showAdModal = ref(false);
  //计算底部的区域应该有多高
  const isShowBottomDiv = ref(false);
  const topContainerRef = ref(null);
  const bottomContainerHeight = ref(0.0);

  const noRedMsgCount = ref(0);

  //预先加载ads图
  const preloadAdsShow = ref(true);
  let preAdTimer = null;
  let downTimer = null;
  //顶部下载
  const isShowTopDownDiv = ref(hdi.fsd ? true : (HNewGameUIConfig.newGameUIType === 0 ? (!hdi.h2d && !hdi.isRunDesktop) : false));

  //合作游戏列表
  const heZuoGameList = ref([]);
  const eachHeZuoImgWidth = ref(0);

  function openService() {
    noRedMsgCount.value = 0;
    useComApi.openService();
  }

  function clickHeZuoGameItem(itemInfo){
    if (itemInfo["Status"] === 1) {
      showToast("游戏维护中,请稍后再来吧");
    } else {
      if(itemInfo["ClickType"] === 2){
        clickModal.onClick(itemInfo);
      }else{
        clickModal.onClick({
              ClickType: itemInfo["ClickType"],
              ClickParam: {
                "name": itemInfo["Title"],
                "paras": itemInfo["ClickParam"],
                "leaveArgument": itemInfo["leaveArgument"],
              }
            }
        );
      }
    }
  }
  function clickTopCloseDown() {
    isShowTopDownDiv.value = false;
    bottomContainerHeight.value = bottomContainerHeight.value + 60;
  }

  function clickTopDown() {
    if (hdi.platTypeNo === 3) {
      hcf.launchUrl(useComApi.h5DownloadIosUrl.value + "?code=" + hdi.inviteCode);
      if (downTimer) {
        clearTimeout(downTimer);
        downTimer = null;
      }
      downTimer = setTimeout(() => {
        showDialog({
          title: 'iPhone轻量版安装步骤',
          message: "\n1.打开 【设置】-【通用】-【VPN与设备管理】\n2.选择《永利皇宫》\n3.点击右上角【安装】按钮\n\n*安装后请返回主屏幕查看\n*如有遇到任何问题,请联系在线客服",
          confirmButtonText: "知道了",
          confirmButtonColor: hcf.getMainColor(),
          messageAlign: "left"
        });
      }, 3000);
    } else {
      hcf.launchUrl(useComApi.h5DownloadApkUrl.value + "?code=" + hdi.inviteCode)
    }
  }

  onMounted(() => {
    emitter.on("PING_PONG_EVENT_NO_RED_MSG", (num) => {
      noRedMsgCount.value = num;
    });
    //合作游戏
    if (HNewGameUIConfig.newGameUIType === 4) {
      eachHeZuoImgWidth.value = (window.innerWidth - 24) / 3;
      useHHttp().request("/qp/game/lobby/jump", (resp) => {
        heZuoGameList.value = resp["ItemList"] ?? [];
      });
    }
    if (HNewGameUIConfig.newGameUIType === 4) {
      bottomContainerHeight.value = 250;
    } else {
      bottomContainerHeight.value = window.innerHeight - topContainerRef.value?.offsetHeight;
      bottomContainerHeight.value -= HNewGameUIConfig.newGameUIType === 0 ? 140 : 110;//减去底部bottom的高度带来的影响
    }
    if (bottomContainerHeight.value !== 0 && !isNaN(bottomContainerHeight.value)) {
      isShowBottomDiv.value = true;
    }
    if (adData.value.length > 0) {
      preloadAdsShow.value = true;
      // if (kRelease) {
        if (preAdTimer) {
          clearTimeout(preAdTimer);
          preAdTimer = null;
        }
        preAdTimer = setTimeout(() => {
          preloadAdsShow.value = false;
          showAdModal.value = true;
        }, 1500);
      // }
    }
  });

  onUnmounted(() => {
    if (preAdTimer) {
      clearTimeout(preAdTimer);
      preAdTimer = null;
    }
    if (downTimer) {
      clearTimeout(downTimer);
      downTimer = null;
    }
  });

  function closeBtn() {
    showAdModal.value = false;

    if(useComApi.downloadDomainList.value.length>0){
      if(hdi.smd){
        emitter.emit("DOWNLOAD_MODAL_VISIBLE",{"visible":true,dList:useComApi.downloadDomainList.value});
      }
    }
  }
</script>


<style scoped>
  .ignore-topDownDiv {
    display: flex;
    flex-direction: Row;
    height: 60px;
    width: 100%;
    align-items: center;
    padding: 0 10px;
    background: linear-gradient(to right, #FFF1C7, #FEF3E1);
  }

  .closeBtn {
    margin-top: 50px;
    margin-left: calc(50% - 15px);
    background-color: #666;
    border-radius: 35px;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .parentDiv {
    display: flex;
    flex: 1;
    flex-direction: column;
    background-color: var(--ct-main-color-bg);
  }

  .topLogoServiceDiv {
    padding: 10px 10px;
    display: flex;
    align-items: center;
  }

  .preLoadAds {
    position: fixed;
    top: -50px;
    left: -50px;
  }
</style>
